import { combineReducers } from "redux";
import Candidate from "./candidateReducer";
import Interview from "./interviewReducer";
import Skills from "./skillsReducer";
import Subscription from "./subscriptionReducer";
import UserAuth from "./userAuthReducer";
import ProductPermission from "./productPermissionReducer";
// [2026-08-12] ADDED — InC-Proctor sign-in handoff.
import Proctoring from "./proctoringReducer";
import LocalDeletion from "./localDeletionReducer";

const appReducer = combineReducers({
  Candidate,
  Interview,
  Skills,
  Subscription,
  UserAuth,
  ProductPermission,
  Proctoring,
  LocalDeletion,
});

const reducers = (state, action) => {
  return appReducer(state, action);
};

export default reducers;
